import { render, staticRenderFns } from "./MenuAutocompleteTrained.vue?vue&type=template&id=5ee9452a"
import script from "./MenuAutocompleteTrained.vue?vue&type=script&lang=js"
export * from "./MenuAutocompleteTrained.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports